<template>
  <div>
    <gm-search
      ref="form"
      @submit="search"
      :defaultValue="keyword"
      :placeholder="$t('search_placeholder')"
    ></gm-search>
    <div class="list-scroll">
      <gm-list
        v-if="problems.length && !problems[0][0]"
        :list="problems"
      ></gm-list>
      <div
        v-else-if="problems.length"
        v-for="item of problems"
        :key="item.id"
      >
        <p class="search-item">{{ item[0] }}</p>
        <gm-list :list="item[1]"></gm-list>
      </div>
      <div
        class="global-list"
        v-else-if="!isGlobal && keyword"
        @click="globalSearch"
      >
          <p>
            <span>{{ $t('global_search') }}</span>
            <span class="blue">{{ keyword }}</span>
            <span class="pull-right icon-next"></span>
          </p>
      </div>
      <p v-else-if="keyword" class="search-item">
        {{ $t('empty_search') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GmSearch from '@/components/Search'
import GmList from '../components/List'

export default {
  name: 'search',
  components: {
    GmSearch,
    GmList
  },
  data() {
    return {
      id: '',
      keyword: '',
      isGlobal: true
    }
  },
  computed: {
    ...mapGetters({
      problems: 'getProblemList'
    })
  },
  activated() {
    const id = (this.$route.query.id || "").toString()
    const keyword = this.$route.query.keyword || ''
    this.keyword = this.id !== id ? keyword : keyword || this.keyword
    if (this.id !== id) {
      this.id = id
      this.init()
    }
    this.$nextTick(() => {
      this.$refs.form.$el[0].click()
      this.$refs.form.$el[0].focus()
    })
  },
  methods: {
    init() {
      this.$store.dispatch('requestData', {
        method: 'search',
        payload: []
      })
    },
    search(v) {
      this.keyword = v
      if (v) {
        const id = this.$route.query.id
        if (id) { this.isGlobal = false }
        this.$store.dispatch('requestSearch', { id, keyword: v })
      } else {
        this.init()
      }
    },
    globalSearch() {
      this.isGlobal = true
      this.$store.dispatch('requestSearch', { keyword: this.keyword })
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === from.name && to.query.id !== from.query.id) {
        this.search(this.keyword)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

p.search-item {
  color: #787879;
  font-size: px2rem(14px);
  margin-top: px2rem(12px);
  margin-bottom: px2rem(4px);
  padding: 0 px2rem(12px);
}
.global-list {
  font-size: px2rem(16px);
  background-color: #fff;
  position: relative;

  p {
    position: relative;
    margin: 0;
    padding: px2rem(24px) px2rem(12px);
    border-bottom: 1px solid #e5e5e5;
  }
  .blue {
    color: #2D8EFE;
  }
  .pull-right {
    position: absolute;
    top: 50%;
    right: px2rem(12px);
    transform: translateY(-50%);

    &.icon-next {
      color: #9B9B9B;
    }
  }
}
.list-scroll {
  height: calc(100vh - 4rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>




// WEBPACK FOOTER //
// src/views/help-center/views/SearchView.vue